import MobileSettingsLink from "./plugins/MobileSettingsLink.js";
import DesktopSettingsLink from "./plugins/DesktopSettingsLink.js";
import SettingsRoute from "./plugins/SettingsRoute.js";
const install = molten => {
  molten.addPlugin('Action', MobileSettingsLink);
  molten.addPlugin('Action', DesktopSettingsLink);
  molten.addPlugin('Route', SettingsRoute);
};
export default {
  install
};